import {useState} from "react";
import className from "classnames/bind";
import {FontAwesomeIcon} from "~/components";
import {fmtMs} from "./ratings";
import style from "../style/PageSpeed.module.scss";

const cn = className.bind(style);

/** 1 mục cải thiện: tiêu đề + badge tiết kiệm + nút "Xem chi tiết" mở mô tả. */
function OppItem({item}) {
	const [open, setOpen] = useState(false);

	return (
		<li className={cn('opp', {open})}>
			<button type="button" className={cn('opp-row')} onClick={() => setOpen((v) => !v)}>
				<span className={cn('opp-caret')}>
					<FontAwesomeIcon icon="fa-light fa-chevron-right" />
				</span>
				<span className={cn('opp-title')}>{item.title}</span>
				<span className={cn('opp-meta')}>
					{item.savingsMs > 0 && (
						<span className={cn('opp-savings')}>Tiết kiệm ~{fmtMs(item.savingsMs)}</span>
					)}
					{item.display && <span className={cn('opp-display')}>{item.display}</span>}
				</span>
			</button>
			{open && (item.description || item.fix || item.evidence?.length) && (
				<div className={cn('opp-detail')}>
					{item.description && <p className={cn('opp-desc')}>{item.description}</p>}

					{item.evidence?.length > 0 && (
						<div className={cn('opp-evi')}>
							<div className={cn('opp-evi-head')}>
								<FontAwesomeIcon icon="fa-light fa-list-check" /> Cần chỉnh ở đây
							</div>
							<ul className={cn('opp-evi-list')}>
								{item.evidence.map((e, i) => (
									<li key={i} className={cn('opp-evi-item')}>
										<span className={cn('opp-evi-label')} title={e.label}>{e.label}</span>
										{e.note && <span className={cn('opp-evi-note')}>{e.note}</span>}
									</li>
								))}
							</ul>
						</div>
					)}

					{item.fix && (
						<div className={cn('opp-fix')}>
							<span className={cn('opp-fix-label')}>
								<FontAwesomeIcon icon="fa-light fa-lightbulb" /> Cách khắc phục
							</span>
							<span>{item.fix}</span>
						</div>
					)}
				</div>
			)}
		</li>
	);
}

/**
 * Danh sách cơ hội cải thiện, GOM NHÓM theo hạng mục (Hiệu suất / SEO / Khả năng
 * truy cập / Thực hành tốt) để người dùng thường dễ đọc. Mỗi mục mở được phần giải
 * thích (mô tả tiếng Việt của Google) để biết cần làm gì.
 */
function Opportunities({items = []}) {
	if (!items.length) {
		return (
			<div className={cn('opps-empty')}>
				<FontAwesomeIcon icon="fa-light fa-circle-check" /> Không phát hiện vấn đề nào cần cải thiện đáng kể.
			</div>
		);
	}

	// Gom theo group, giữ thứ tự ưu tiên hạng mục.
	const order = ['Hiệu suất', 'Khả năng truy cập', 'Thực hành tốt', 'SEO', 'Khác'];
	const groups = {};
	items.forEach((it) => {
		const g = it.group || 'Khác';
		(groups[g] = groups[g] || []).push(it);
	});
	const sortedGroups = Object.keys(groups).sort((a, b) => order.indexOf(a) - order.indexOf(b));

	return (
		<div className={cn('opps')}>
			<div className={cn('opps-head')}>
				<FontAwesomeIcon icon="fa-light fa-wrench" /> Cần cải thiện
				<span className={cn('opps-hint')}>Bấm từng mục để xem giải thích &amp; cách khắc phục</span>
			</div>

			{sortedGroups.map((g) => (
				<div className={cn('opp-group')} key={g}>
					<div className={cn('opp-group-title')}>{g} <span>({groups[g].length})</span></div>
					<ul className={cn('opps-list')}>
						{groups[g].map((it) => <OppItem key={it.id} item={it} />)}
					</ul>
				</div>
			))}
		</div>
	);
}

export default Opportunities;
